enum DeviceType {
  SCO = 'sco',
  Gatekeeper = 'gatekeeper',
}

export default DeviceType;
